import { AbsoluteFill, useCurrentFrame, useCurrentScale } from "remotion";
import { CompositionTimings } from "../../utils/timing.ts";
import { getElementsByScene, getStartScene } from "@repo/api/utils/composition";
import { CompositionDto, I2VCompositionProps } from "@repo/api/editor";
import ElementsLayer from "../Element/ElementsLayer.tsx";

type Props = {
  composition: CompositionDto;
  timings: CompositionTimings;
  assetMedias: I2VCompositionProps["assetMedias"];
  isStudio: boolean;
  isPlaying: boolean;
};

export default function StartScene({
  composition,
  assetMedias,
  timings,
  isStudio,
  isPlaying,
}: Props) {
  const elements = getElementsByScene(composition, "startScene");
  const scale = useCurrentScale() || 1;
  const frame = useCurrentFrame();

  const isStackedOnMainScene =
    getStartScene(composition)?.exitTransition?.kind === "STACKED" &&
    !!timings.startScene &&
    frame >=
      timings.startScene.durationInFrames -
        timings.startScene.exitTransitionFrames;

  return (
    <AbsoluteFill className={isStackedOnMainScene ? "" : "bg-black"}>
      {elements.length === 0 && isStudio && !isStackedOnMainScene && (
        <div className="flex h-full w-full items-center justify-center">
          <div
            className="text-gray-300 font-medium text-center"
            style={{
              fontSize: 14 / scale,
              paddingRight: 24 / scale,
              paddingLeft: 24 / scale,
            }}
          >
            Start by adding an element to the start scene
          </div>
        </div>
      )}

      {elements.length > 0 && (
        <ElementsLayer
          elements={elements}
          elementTimings={timings.startScene?.elementTimings ?? {}}
          assetMedias={assetMedias}
          sceneType="startScene"
          isPlaying={isPlaying}
        />
      )}
    </AbsoluteFill>
  );
}
